<div class="bg-primary d-none d-lg-block">
  <div class="container">
    <div class="page-back-button-section mb-2" [routerLink]="['/games']">
      <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
    </div>
    <img class="mb-3 w-100" src="assets/images/games/PredictorGameBanner.png" />
    <fgb-game-nav routeLink="predictor" />
  </div>
</div>
<fgb-page-header [pageTitle]="'games.page.predictor.title'" [showBalance]="true" [backButtonLink]="'/games'">
  <ng-template>
    <img src="assets/images/games/PredictorGameBanner.png" />
    <fgb-game-nav routeLink="predictor" />
  </ng-template>
</fgb-page-header>
<router-outlet></router-outlet>
